'use client';

import Container from '../container';
import Image from '@/components/image';
import Title from '../typography/title';
import { useState } from 'react';
import useProducts from '@/hooks/useProducts';
import { Autoplay, Grid } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import LoadingProductCard from '../cards/loading-product-card';
import { ProductCard } from '../cards';
import { filterIsInStockProducts } from '@/utils/product';
import NextLink from '@/components/next-link';
import { event_select_promotion, event_view_promotion } from '@/utils/gtm';
import useInViewPort from '@/hooks/useInViewPort';

const DealsSlider = ({ data, isMobile }) => {
  const { locale, allProducts, isMutating } = useProducts(data, 'deals-slider');
  const [swiper, set_swiper] = useState({});
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const fireViewPromotion = () => {
    if (data?.value?.length > 0) {
      const updatedData = data?.value?.map((item) => ({
        promotionImage: item?.[`img-${locale}`],
        key: 'deals',
        position: data?.position,
        id: item?.id,
        name: data?.[`title-${locale}`],
      }));
      event_view_promotion(updatedData);
    }
  };
  const [ref] = useInViewPort(fireViewPromotion);

  return (
    <Container>
      <Title
        title={data?.[`title-${locale}`]}
        hasArrows
        swiper={swiper}
        isBeginning={isBeginning}
        isEnd={isEnd}
        locale={locale}
        data={data}
        isMobile={isMobile}
        hasMore={data?.value?.[0]?.['show-more-btn']}
        href={data?.value?.[0]?.url ? `/${data?.value?.[0]?.url}` : '#'}
      />
      <div className='flex gap-2.5 sm:mt-4 sm:gap-6'>
        <NextLink
          href={data?.value?.[0]?.url ? `/${data?.value?.[0]?.url}` : '#'}
          ref={ref}
          onClick={() =>
            event_select_promotion({
              promotionImage: data?.value?.[0]?.[`img-${locale}`],
              key: 'deals',
              position: data?.position,
              id: data?.value?.[0]?.id,
              name: data?.[`title-${locale}`],
              url: data?.value?.[0]?.url ? `/${data?.value?.[0]?.url}` : '#',
            })
          }
          className='max-lg:max-w-[180px] max-lg:min-w-[180px] max-sm:max-w-[142px] max-sm:min-w-[142px] lg:max-w-[260px] lg:min-w-[260px]'
        >
          <Image
            src={
              isMobile
                ? data?.value?.[0]?.[`mobile-img-${locale}`]
                : data?.value?.[0]?.[`img-${locale}`]
            }
            className='w-full rounded-lg max-lg:max-h-73 max-lg:min-h-73 max-md:max-h-71 max-md:min-h-71 max-sm:max-h-66 max-sm:min-h-66 md:h-full'
            alt={data?.value?.[0]?.[`alt-${locale}`] || 'Banner Img!!'}
          />
        </NextLink>
        {/* <section className='col-span-8 md:col-span-9 lg:col-span-10'> */}
        <section className='contents flex-1'>
          <Swiper
            onInit={(e) => set_swiper(e)}
            dir={locale === 'en' ? 'ltr' : 'rtl'}
            key={locale}
            modules={[Grid, Autoplay]}
            autoplay={{ delay: 3500, pauseOnMouseEnter: true }}
            spaceBetween={24}
            slidesPerView='auto'
            grid={{ rows: 2, fill: 'row' }}
            breakpoints={{
              320: { spaceBetween: 10, grid: { rows: 1, fill: 'row' } },
              1024: { slidesPerView: 4, slidesPerView: 4 },
            }}
            onSlideChange={(swiper) => {
              setIsBeginning(swiper.isBeginning);
              setIsEnd(swiper.isEnd);
            }}
          >
            {isMutating
              ? [...Array(5).keys()].map((i) => (
                  <SwiperSlide
                    key={i}
                    className='max-lg:max-w-46 max-lg:min-w-46 max-md:max-w-42 max-md:min-w-42 max-sm:max-w-36 max-sm:min-w-36'
                  >
                    <LoadingProductCard />
                  </SwiperSlide>
                ))
              : filterIsInStockProducts(allProducts)?.map((product, index) => (
                  <SwiperSlide
                    key={index}
                    className='max-lg:max-w-46 max-lg:min-w-46 max-md:max-w-42 max-md:min-w-42 max-sm:max-w-36 max-sm:min-w-36'
                  >
                    <ProductCard product={product} />
                  </SwiperSlide>
                ))}
          </Swiper>
        </section>
      </div>
    </Container>
  );
};

export default DealsSlider;
